/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Nav_HowInputs */

const en_platform_nav_how = /** @type {(inputs: Platform_Nav_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to start`)
};

const pl_platform_nav_how = /** @type {(inputs: Platform_Nav_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak zacząć`)
};

/**
* | output |
* | --- |
* | "How to start" |
*
* @param {Platform_Nav_HowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_nav_how = /** @type {((inputs?: Platform_Nav_HowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Nav_HowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_nav_how(inputs)
	return en_platform_nav_how(inputs)
});